/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Location_TitleInputs */

const vi_camera_location_title = /** @type {(inputs: Camera_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nơi đặt camera`)
};

/**

* @param {Camera_Location_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_location_title = /** @type {((inputs?: Camera_Location_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Location_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_location_title(inputs)
});